import ProductCardBackButton from './ProductCardBackButton';
import ProductCardBenefits from './ProductCardBenefits';
import ProductCardCheckoutGroup from './ProductCardCheckoutGroup';
import ProductCardFront from './ProductCardFront';
import ProductCardRoot from './ProductCardRoot';
import ProductCardWhatsIncluded from './ProductCardWhatsIncluded';
import ProductCardWhatsIncludedHeading from './ProductCardWhatsIncludedHeading';
import ProductCardWhatsIncludedImage from './ProductCardWhatsIncludedImage';
import ProductCardWhatsIncludedTrigger from './ProductCardWhatsIncludedTrigger';

export { useProductCard } from './context';
export { type CardFace, faceComponentName } from './faceComponentName';

const ProductCard = {
  Root: ProductCardRoot,
  Front: ProductCardFront,
  WhatsIncluded: ProductCardWhatsIncluded,
  WhatsIncludedTrigger: ProductCardWhatsIncludedTrigger,
  WhatsIncludedHeading: ProductCardWhatsIncludedHeading,
  WhatsIncludedImage: ProductCardWhatsIncludedImage,
  Benefits: ProductCardBenefits,
  CheckoutGroup: ProductCardCheckoutGroup,
  BackButton: ProductCardBackButton,
};

export default ProductCard;
